<template>
    <div v-if="table && table.length">
        <h2 class="h1 text--center">Table</h2>

        <div class="panel bg--layer-dark mb--md">
            <table class="text--sm">
                <tr v-for="row in orderedTable">
                    <td class="pl--0">
                        <div class="profile profile--inline profile--horizontal">
                            <figure class="profile__avatar">
                                    <span class="profile__avatar__img"><img src="/img/pictures/avatar-1.jpg"
                                                                            alt=""/></span>
                            </figure>

                            <div class="profile__text">
                                <div class="profile__name">{{ row.nick }}</div>
                            </div>
                        </div>
                    </td>
                    <td class="pr--0 text--right">
                        {{ row.point || 0 }} ({{ row.matches }}/{{ row.wins || 0 }})
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['table'],

        computed: {
            orderedTable() {
                return collect(this.table).sortByDesc('point')
            },
        }
    }
</script>
